import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const Media = () => {
  return <SingleContentPage title="Media" moduleKey="media" />;
};

export default Media;
